import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {m_taxonomy} from "~/services/classes/TaxonomyClasses";
import {taxonomyDetailUrl} from "~/pages/taxonomy-builder-v2/services/taxonomyBuilderUrls";

/**
 * The taxonomy with its full tree (`GET taxonomy/{id}/`), the same endpoint the current builder loads.
 * Read only: edits still go through `TaxonomyManagerStore` (`store_state`).
 */
export function useTaxonomyQuery(taxonomyId: number | null) {
    const url = taxonomyId ? taxonomyDetailUrl(taxonomyId) : '';
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<m_taxonomy.FullSerializer>(url)).data,
        enabled: Boolean(taxonomyId),
    });
}
